/**
 * Timestamps from PSM.
 *
 * PSM stores JST wall-clock and some endpoints send it without an offset
 * ("2026-10-13 13:28:50"). `new Date()` would read that as the browser's own
 * zone (6 hours off in Nairobi) or reject it (Safari, space separator), so a
 * value without an offset is taken as JST. Values with an offset ("…Z",
 * "…+09:00", "…+09") are taken as they are.
 */
const NO_OFFSET = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)$/;
const SHORT_OFFSET = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)([+-]\d{2})$/;

export function parsePortalTime(value: string | null | undefined): Date | null {
  if (!value) return null;
  const s = value.trim();
  let iso = s;
  const bare = NO_OFFSET.exec(s);
  if (bare) iso = `${bare[1]}T${bare[2]}+09:00`;
  const short = SHORT_OFFSET.exec(s);
  if (short) iso = `${short[1]}T${short[2]}${short[3]}:00`;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}
